import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { MODAL_TYPE_CLIENT_MYPAGE_CONSIDERATION, MODAL_TYPE_CLIENT_MYPAGE_ORDER, MODAL_TYPE_CLIENT_MYPAGE_REVIEW, MODAL_TYPE_CLIENT_MYPAGE_SEND_OFF, } from '../../../../actions/ModalActions';
import { propBool } from '../../../../helpers/custom-prop-types';
import { isShowModal } from '../../../../helpers/modal';
import ModalClientReview from './Modal/ModalClientReview';
import ModalConfirmConsideration from './Modal/ModalConfirmConsideration';
import ModalConfirmOrder from './Modal/ModalConfirmOrder';
import ModalConfirmSendOff from './Modal/ModalConfirmSendOff';
const ModalSelector = (props) => {
    const { isModalClientReview, isModalConfirmOrderShown, isModalConfirmSendOffShown, isModalUseConsideration, } = props;
    if (isModalConfirmOrderShown)
        return _jsx(ModalConfirmOrder, {});
    if (isModalConfirmSendOffShown)
        return _jsx(ModalConfirmSendOff, {});
    if (isModalClientReview)
        return _jsx(ModalClientReview, {});
    if (isModalUseConsideration)
        return _jsx(ModalConfirmConsideration, {});
    return null;
};
ModalSelector.propTypes = {
    isModalClientReview: propBool().isRequired,
    isModalConfirmOrderShown: propBool().isRequired,
    isModalConfirmSendOffShown: propBool().isRequired,
    isModalUseConsideration: propBool().isRequired,
};
const mapStateToProps = ({ modal }) => ({
    isModalClientReview: isShowModal(modal, MODAL_TYPE_CLIENT_MYPAGE_REVIEW),
    isModalConfirmOrderShown: isShowModal(modal, MODAL_TYPE_CLIENT_MYPAGE_ORDER),
    isModalConfirmSendOffShown: isShowModal(modal, MODAL_TYPE_CLIENT_MYPAGE_SEND_OFF),
    isModalUseConsideration: isShowModal(modal, MODAL_TYPE_CLIENT_MYPAGE_CONSIDERATION),
});
const enhance = compose(connect(mapStateToProps));
export default enhance(ModalSelector);
